import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const LockIconGray: FC<IconProps> = ({ width = 16, height = 20, ...rest }) => (
  <Icon type="LockGray" width={width} height={height} alt="iconLockGray" ignoreRtl {...rest} />
)
